export default __webpack_public_path__ + "static/avoid_cheating_img-216c01ea49cf2cb8156d338fb5332f67.webp";